import { render, staticRenderFns } from "./changeDuty.vue?vue&type=template&id=5475c2f6&scoped=true"
import script from "./changeDuty.vue?vue&type=script&lang=js"
export * from "./changeDuty.vue?vue&type=script&lang=js"
import style0 from "./changeDuty.vue?vue&type=style&index=0&id=5475c2f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5475c2f6",
  null
  
)

export default component.exports